// The browser cancels every in-flight request when the page goes away, so leaving the app — an
// external link, an OAuth redirect, a reload — rejects them all as "Failed to fetch" for our hosts
// and third parties alike. pagehide covers both flavours: discarded, and frozen for bfcache. Neither
// is actionable, and a frozen page runs no JS, so latching on both is safe — pageshow always fires on
// restore and unlatches before the page can issue another request.

// On window rather than in a module variable: the same module can be evaluated more than once - a
// worker bundle, a @prophecy package's own dist - and a second copy would read its own flag forever.
const UNLOADING_KEY = '__prophecyPageUnloading';

type UnloadFlagHolder = { [UNLOADING_KEY]?: boolean };

export function listenForPageUnload() {
  window.addEventListener('pagehide', () => {
    (window as UnloadFlagHolder)[UNLOADING_KEY] = true;
  });
  window.addEventListener('pageshow', () => {
    (window as UnloadFlagHolder)[UNLOADING_KEY] = false;
  });
}

export const isNavigatingAway = () => Boolean((window as UnloadFlagHolder)[UNLOADING_KEY]);
